import { Typography } from "@mui/material";

const ClampedText = ({
  variant = "body2",
  sx,
  color,
  children,
  ...props
}) => {
  return (
    <Typography
      variant={variant}
      sx={{
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "400px",
        ...sx,
      }}
      color={color}
      {...props}
    >
      {children}
    </Typography>
  );
};

export default ClampedText;
